import { VegaCard, VegaFlex, VegaFont } from '@globalpayments/vega-react';
import { format } from 'date-fns';
import { getDate } from '../../configInfo/components/Functions';
import { event } from './Interfaces';

interface Props {
  event: event;
  delay: number;
  animate: boolean;
}

const Event: React.FC<Props> = ({ event, delay, animate }) => {
  const date = format(getDate(new Date(event.dateUTC)), 'MM/dd/yyyy, hh:mm:ssaaa');

  return (
    <div
      className={animate ? 'session-info-activity session-info-activity--animate' : 'session-info-activity'}
      style={animate ? { animationDelay: `${delay}ms` } : undefined}>
      <VegaCard padding="size-16" variant="border">
        <VegaFlex direction="col" gap="size-8">
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Date: </strong>
            {date}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Type: </strong>
            {event.type}
          </VegaFont>
          <VegaFont as="p" color="text-primary" variant="font-p2-short">
            <strong>Description: </strong>
            {event.description}
          </VegaFont>
        </VegaFlex>
      </VegaCard>
    </div>
  );
};

export default Event;
